import React from "react";

export function PortfolioItem({ item, labels }) {
  return (
    <div className="pb-5 text-center item-portfolio">
      <img className="bg-white mb-3 image-portfolio" src={item.image} alt={item.name} />
      <p className="lead title-portfolio">{item.name}</p>
      <p className="lead language">{labels.stackLabel}: {item.language}</p>

      <div className="container-links-mobile">

        {item?.linkAndroid &&

          <a className="lead link-portfolio" target={'_blank'} href={item.linkAndroid}>
            {labels.androidLabel}
          </a>
        }

        {item?.linkIos &&
          <a className="lead link-portfolio" target={'_blank'} href={item.linkIos}>
            {labels.iosLabel}
          </a>
        }

        {item?.link &&
          <a className="lead link-portfolio" target={'_blank'} href={item.link}>
            {labels.siteLabel}
          </a>
        }

        {item?.github &&
          <a className="lead link-portfolio" target={'_blank'} href={item.github}>
            {labels.githubLabel}
          </a>
        }

      </div>




    </div>
  );
}

